import { createRouter, createWebHistory } from 'vue-router';
import axios from '@/plugins/axios';

/** @Account */
import Login from '@/views/Account/Login.vue';
// import Signup from '@/views/Account/Signup.vue';
import SignupPassword from '@/views/Account/SignupPassword.vue';
import ForgotPassword from '@/views/Account/ForgotPassword.vue';
import ResetPassword from '@/views/Account/ResetPassword.vue';

/** @Edits */
import EditEmail from '@/views/Edit/Email.vue';
import EditUpdatedEmail from '@/views/Edit/UpdatedEmail.vue';
import EditPassword from '@/views/Edit/Password.vue';
import EditProfile from '@/views/Edit/Profile.vue';

/** @Admin */
import Admin from '@/views/Admin/Admin.vue';
import AdminMenu from '@/views/Admin/Menu.vue';
import AdminUser from '@/views/Admin/User.vue';
import AdminAdminUser from '@/views/Admin/AdminUser.vue';
import AdminMenuItem from '@/views/Admin/MenuItem.vue';
import AdminTablet from '@/views/Admin/Tablet.vue';

/** @Pages */
import StaffCalled from '@/views/Pages/StaffCalled.vue';
import Welcome from '@/views/Pages/Welcome.vue';
import OrderComplete from '@/views/Pages/OrderComplete.vue';
import OrderList from '@/views/Pages/OrderList.vue';
import Checkout from '@/views/Pages/Checkout.vue';
import CheckoutList from '@/views/Pages/CheckoutList.vue';
import CheckoutConfirm from '@/views/Pages/CheckoutConfirm.vue';
import Menu from '@/views/Pages/Menu.vue';
import MenuMobile from '@/views/Pages/MenuMobile.vue';
import Tokushohou from '@/views/Pages/Tokushohou.vue';
import Terms from '@/views/Pages/Terms.vue';
import Policy from '@/views/Pages/Policy.vue';

import store from '../store';

const routes = [

  /** @Account */
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'ログイン',
    },
  },
  // {
  //   path: '/signup',
  //   name: 'Signup',
  //   component: Signup,
  //   meta: {
  //     title: 'ユーザー仮登録',
  //   },
  // },
  {
    path: '/signup/password',
    name: 'SignupPassword',
    component: SignupPassword,
    meta: {
      title: 'ユーザー登録',
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      title: 'パスワード再発行',
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      title: 'パスワード再設定',
      description: '',
      og_image: '',
    },
  },

  /** @Edits */
  {
    path: '/edit/email',
    name: 'edit-email',
    component: EditEmail,
    meta: {
      title: 'メールアドレス更新',
    },
  },
  {
    path: '/edit/email/updated',
    name: 'updated-email',
    component: EditUpdatedEmail,
    meta: {
      title: 'メールアドレス更新完了',
    },
  },
  {
    path: '/edit/password',
    name: 'edit-password',
    component: EditPassword,
    meta: {
      title: 'パスワード変更',
    },
  },
  {
    path: '/edit/profile',
    name: 'edit-profile',
    component: EditProfile,
    meta: {
      title: 'プロフィール変更',
    },
  },

  /** @Admin */
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      title: '管理者',
    },
  },
  {
    path: '/admin/menu-items',
    name: 'AdminMenuItem',
    component: AdminMenuItem,
    meta: {
      title: 'メニュー商品管理',
    },
  },
  {
    path: '/admin/menus',
    name: 'AdminMenu',
    component: AdminMenu,
    meta: {
      title: 'メニュー管理',
    },
  },
  {
    path: '/admin/users',
    name: 'AdminUser',
    component: AdminUser,
    meta: {
      title: 'ユーザー管理',
    },
  },
  {
    path: '/admin/admin-users',
    name: 'AdminAdminUser',
    component: AdminAdminUser,
    meta: {
      title: '管理者管理',
    },
  },
  {
    path: '/admin/tablets',
    name: 'AdminTablet',
    component: AdminTablet,
    meta: {
      title: '注文タブレット管理',
    },
  },
  /** @Pages */
  {
    path: '/',
    name: 'welcome',
    component: Welcome,
    meta: {
      title: '注文開始',
    },
  },
  {
    path: '/staff-called',
    name: 'staff-called',
    component: StaffCalled,
    meta: {
      title: 'スタッフ呼び出し',
    },
  },
  {
    path: '/checkout-confirm',
    name: 'checkout-confirm',
    component: CheckoutConfirm,
    meta: {
      title: '会計確認',
    },
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: Checkout,
    meta: {
      title: 'お会計',
    },
  },
  {
    path: '/checkout-list',
    name: 'checkout-list',
    component: CheckoutList,
    meta: {
      title: 'お会計一覧',
    },
  },
  {
    path: '/order-complete',
    name: 'order-complete',
    component: OrderComplete,
    meta: {
      title: 'ご注文完了',
    },
  },
  {
    path: '/order-list',
    name: 'order-list',
    component: OrderList,
    meta: {
      title: '注文一覧',
    },
  },
  {
    path: '/menu',
    name: 'menu',
    component: Menu,
    meta: {
      title: 'メニュー画面',
    },
  },
  {
    path: '/menu-mobile',
    name: 'menu-mobile',
    component: MenuMobile,
    meta: {
      title: 'メニュー',
    },
  },
  {
    path: '/tokushohou',
    name: 'tokushohou',
    component: Tokushohou,
    meta: {
      title: '特商法に基づく表記',
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms,
    meta: {
      title: '利用規約',
    },
  },
  {
    path: '/policy',
    name: 'policy',
    component: Policy,
    meta: {
      title: 'プライバシーポリシー',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

/** ページパスワード認証が必要なパス */
const requiredPageAuthPageNames = [
  '/admin', 
  // '/order-list', 
  // '/checkout-list',
];

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isLoggedIn = store.state.user.login.isLogin;

  if (requiresAuth && !isLoggedIn) {
    try {
      await store.dispatch('user/login/check');
    } catch (error) {
      alert('このページを閲覧するにはログインが必要です。');
      return next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    }
  }

  const isPageAuthRequired = requiredPageAuthPageNames.some((pageName) => to.path.startsWith(pageName));

  if (!isPageAuthRequired) {
    next();
    return;
  }

  try {
    await axios.get('/v1/pageauth/check', { withCredentials: true });
    next();
  } catch (error) {
    if (error.response && error.response.status === 401) {
      const inputPassword = prompt('このページはパスワードで保護されています。\nログインパスワードを入力してください。');
      if (inputPassword === null) {
        next();
        return;
      }

      try {
        await axios.post('/v1/pageauth/login', { password: inputPassword }, { withCredentials: true });
        next();
      } catch (loginError) {
        alert('ページ認証に失敗しました。');
        next('/');
      }
    } else {
      console.error('ページ認証チェック中にエラーが発生しました:', error);
      next('/');
    }
  }
});

export default router;
